// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__MLHlh","dragIcon":"Choice_dragIcon__11M-t","left":"Choice_left__qsO0V","input":"Choice_input__BlVWf"};